import { Server, Globe, Zap, Wrench } from "lucide-react";

export const getToolIcon = (toolType?: string) => {
  switch (toolType) {
    case "mcp_server":
      return <Server className="h-5 w-5 text-white" />;
    case "api":
      return <Zap className="h-5 w-5 text-white" />;
    case "webhook":
      return <Globe className="h-5 w-5 text-white" />;
    case "graphql":
      return <Zap className="h-5 w-5 text-white" />;
    default:
      return <Wrench className="h-5 w-5 text-white" />;
  }
};